module.exports = __webpack_public_path__ + "img/capteur.f88bfd65.png";